import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';

const SLIDES = [
  {
    title: 'Calendário',
    body: 'Veja seus plantões do mês de relance. Toque em um dia para iniciar, encerrar ou agendar.',
    accent: 'Veja os plantões do mês',
  },
  {
    title: 'Produção',
    body: 'Registre cada exame ou procedimento com 1 toque. Total ao vivo, com desfazer imediato.',
    accent: '1 toque = 1 item',
  },
  {
    title: 'Fiscal',
    body: 'Anexe o relatório, deixe o OCR ler e a NFS-e é emitida automaticamente. Divergências chegam por WhatsApp.',
    accent: 'NFS-e sem portal',
  },
] as const;

export function OnboardingTour({ onFinish }: { onFinish: () => void }) {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  const slide = SLIDES[index];
  const isLast = index === SLIDES.length - 1;

  const finish = () => {
    onFinish();
    navigate('/calendar', { replace: true });
  };

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 text-center">
      <div className="w-full rounded-lg border border-(--color-border) bg-(--color-surface) p-8">
        <p className="text-xs font-medium tracking-wide text-(--color-accent) uppercase">
          {slide.accent}
        </p>
        <h2 className="mt-3 font-display text-3xl font-semibold">{slide.title}</h2>
        <p className="mt-4 text-sm text-(--color-fg-muted)">{slide.body}</p>

        <div className="mt-8 flex items-center justify-center gap-2" aria-hidden>
          {SLIDES.map((_, i) => (
            <span
              key={i}
              className={`h-1.5 w-6 rounded-full ${
                i === index ? 'bg-(--color-accent)' : 'bg-(--color-border)'
              }`}
            />
          ))}
        </div>
      </div>

      <div className="mt-6 flex w-full items-center justify-between gap-3">
        <Button variant="ghost" onClick={finish}>
          Pular tour
        </Button>
        {isLast ? (
          <Button onClick={finish}>Começar</Button>
        ) : (
          <Button onClick={() => setIndex((i) => i + 1)}>Próximo</Button>
        )}
      </div>
    </div>
  );
}
